import { RouterModule, Routes } from '@angular/router'
import { NgModule } from '@angular/core'
import { AuthGuard } from '../../../services/guarad/auth.guard'
import { SelectClientComponent } from './select-client/select-client.component'
import { NewClientComponent } from './new-client/new-client.component'
import { LayoutAppElementComponent } from '../layout_app_element/layout-app-element.component'
import { PendingChangesGuard } from '../../../services/guarad/pending-changes.guard'
import { AvailabilityGuard } from '../../../services/guarad/availability.guard'

const routes: Routes = [
    {
        path: 'app/main/client', canActivate: [AuthGuard, AvailabilityGuard], component: LayoutAppElementComponent,
        children: [
            { path: '', redirectTo: 'search', pathMatch: 'full' },
            {
                path: 'search',
                component: SelectClientComponent,
                pathMatch: 'full',
                canDeactivate: [PendingChangesGuard],
            },
            { path: 'new', component: NewClientComponent, canDeactivate: [PendingChangesGuard] },
        ],
    },
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})

export class ClientRoutingModule {

}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/client/client.routing.ts